<div class="reusable-modal-container">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
      <ng-container *ngTemplateOutlet="modalBody"></ng-container>
    </div>
    <div class="modal-footer">
      <ng-content select="[modal-footer]"></ng-content>
      <div class="submit-actions">
        <button *ngIf="showCancelButton" type="button" class="btn secondary-button" (click)="cancel()">
          {{ cancelButtonText }}
        </button>
        <button *ngIf="showSaveButton" type="button" class="btn primary-button" (click)="save()">
          {{ saveButtonText }}
        </button>
      </div>
    </div>
</div>
  